import { render, staticRenderFns } from "./user-center.vue?vue&type=template&id=5af2bead&scoped=true&"
import script from "./user-center.vue?vue&type=script&lang=js&"
export * from "./user-center.vue?vue&type=script&lang=js&"
import style0 from "./user-center.vue?vue&type=style&index=0&id=5af2bead&prod&lang=scss&scoped=true&"
import style1 from "./user-center.vue?vue&type=style&index=1&id=5af2bead&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af2bead",
  null
  
)

export default component.exports